import React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { Card, SimpleTable, SimpleTableHeader } from 'components';
import { useLocalErrorHandler } from 'hooks';
import { Color } from '_helpers';
import moment from 'moment';

const ExpertQualificationsContainer = ({
    qualificationsList, getQualificationsList, apiError, setErrorHandler, onPush,
}: Props) => {
    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getQualificationsList();
            setProcessing(false);
        };

        fetch();
    }, []);

    useLocalErrorHandler(setErrorHandler);

    const listTableHeaders: SimpleTableHeader[] = [
        { title: 'КВАЛИФИКАЦИЯ', columnStyles: { width: '100%' }, fieldName: 'title' },
        { title: 'СОК ДЕЙСТВИЯ', columnStyles: { minWidth: '12rem' }, fieldName: 'expireDate' },
        { title: 'СТАТУС', fieldName: 'issueDate' },
    ];

    const checkCertificateStatus = (issueDate: moment.Moment, expireDate: moment.Moment): boolean => moment().isBetween(issueDate, expireDate);

    const renderStatus = (isActualCertificate: boolean) => (
        <span style={{ color: `var(${isActualCertificate ? Color.Success : Color.Red})` }}>
            {isActualCertificate ? 'Действует' : 'Не действует'}
        </span>
    );

    const listTableRows = qualificationsList && qualificationsList.map(({
        examApplicationId, title, issueDate, expireDate,
    }) => ({
        id: examApplicationId,
        columns: [
            title,
            `${issueDate.format('DD.MM.YYYY')} - ${expireDate.format('DD.MM.YYYY')}`,
            renderStatus(checkCertificateStatus(issueDate, expireDate)),
        ],
    }));

    return (
        <Card
          withoutPadding
          title="Мои квалификации"
          category="Список квалификаций, присвоенных вам, как эксперту"
          apiError={apiError}
          showLoader={processing}
          show404Error={!listTableRows}
        >
            {listTableRows && (
                <SimpleTable
                  tableHeaders={listTableHeaders}
                  tableRows={listTableRows}
                  handleRowClick={examApplicationId => onPush(`/qualification-detail/${examApplicationId}`)}
                  placeholderText=" "
                />
            )}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    qualificationsList: state.expert.qualificationsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getQualificationsList: dispatch.expert.getQualificationsListAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    onPush: (key: string) => dispatch(push(key)),
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;

export default connect(mapState, mapDispatch)(ExpertQualificationsContainer);
